/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AdminInfo7 } from '../model/adminInfo7';
import { BatchDefinitionRequestType } from '../model/batchDefinitionRequestType';
import { BatchDefinitionResponseType } from '../model/batchDefinitionResponseType';
import { BatchDownloadResend } from '../model/batchDownloadResend';
import { BatchFileInfoResponseList } from '../model/batchFileInfoResponseList';
import { BatchJobDownloadRequestInfo } from '../model/batchJobDownloadRequestInfo';
import { BatchRequest } from '../model/batchRequest';
import { BatchResponseList } from '../model/batchResponseList';
import { BatchResponseList2 } from '../model/batchResponseList2';
import { BatchResponseList3 } from '../model/batchResponseList3';
import { DataPipeLineCreateRequestType } from '../model/dataPipeLineCreateRequestType';
import { DataPipeLineCreateResponseType } from '../model/dataPipeLineCreateResponseType';
import { DataPipeLineHistRetrieveList } from '../model/dataPipeLineHistRetrieveList';
import { DataPipeLineRetrieveRequestType } from '../model/dataPipeLineRetrieveRequestType';
import { DataPipeLineRetrieveResponseTypeList } from '../model/dataPipeLineRetrieveResponseTypeList';
import { DataPipeLineRetrieveResponseTypeList2 } from '../model/dataPipeLineRetrieveResponseTypeList2';
import { DataPipeLineRetrieveResponseTypeList3 } from '../model/dataPipeLineRetrieveResponseTypeList3';
import { DataPipeLineUpdateRequestType } from '../model/dataPipeLineUpdateRequestType';
import { DataPipeLineUpdateResponseType } from '../model/dataPipeLineUpdateResponseType';
import { DataProcessorResponseList } from '../model/dataProcessorResponseList';
import { DataProviderInfoRequestType } from '../model/dataProviderInfoRequestType';
import { DataProviderInfoResponseType } from '../model/dataProviderInfoResponseType';
import { DataProviderSubListRequestType } from '../model/dataProviderSubListRequestType';
import { DataProviderSubListResponseType } from '../model/dataProviderSubListResponseType';
import { ErrorMessage } from '../model/errorMessage';
import { GetDataSourceResponseInfoList } from '../model/getDataSourceResponseInfoList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BatchMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * BatchMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo7>;
    public batchMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo7>>;
    public batchMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo7>>;
    public batchMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo7>(`${this.basePath}/BatchMgr/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatchFileInfoList, Retrieve Batch File Info
     * Retrieve Batch File Info
     * @param DataPipeLineId Enter the DataPipeLineId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchBatchFileInfoGet(DataPipeLineId: number, observe?: 'body', reportProgress?: boolean): Observable<BatchFileInfoResponseList>;
    public batchMgrV1BatchBatchFileInfoGet(DataPipeLineId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchFileInfoResponseList>>;
    public batchMgrV1BatchBatchFileInfoGet(DataPipeLineId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchFileInfoResponseList>>;
    public batchMgrV1BatchBatchFileInfoGet(DataPipeLineId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (DataPipeLineId === null || DataPipeLineId === undefined) {
            throw new Error('Required parameter DataPipeLineId was null or undefined when calling batchMgrV1BatchBatchFileInfoGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (DataPipeLineId !== undefined) {
            queryParameters = queryParameters.set('DataPipeLineId', <any>DataPipeLineId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<BatchFileInfoResponseList>(`${this.basePath}/BatchMgr/V1/Batch/BatchFileInfo`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatchDefinitionByType, Retrieve BatchDefinitions by type
     * Retrieve BatchDefinitions by type
     * @param Type Enter the type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchDefinitionGet(Type: string, observe?: 'body', reportProgress?: boolean): Observable<BatchDefinitionResponseType>;
    public batchMgrV1BatchDefinitionGet(Type: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionGet(Type: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionGet(Type: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Type === null || Type === undefined) {
            throw new Error('Required parameter Type was null or undefined when calling batchMgrV1BatchDefinitionGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Type !== undefined) {
            queryParameters = queryParameters.set('Type', <any>Type);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<BatchDefinitionResponseType>(`${this.basePath}/BatchMgr/V1/BatchDefinition`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_DeleteBatchDefinition, Delete BatchDefinition
     * Delete BatchDefinition
     * @param Id Enter the DataPipeLineId that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchDefinitionIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<BatchDefinitionResponseType>;
    public batchMgrV1BatchDefinitionIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling batchMgrV1BatchDefinitionIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<BatchDefinitionResponseType>(`${this.basePath}/BatchMgr/V1/BatchDefinition/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_UpdateBatchDefinition, Update BatchDefinition
     * Update BatchDefinition
     * @param Id Enter the BatchDefinition that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchDefinitionIdPut(Id: number, Request: BatchDefinitionRequestType, observe?: 'body', reportProgress?: boolean): Observable<BatchDefinitionResponseType>;
    public batchMgrV1BatchDefinitionIdPut(Id: number, Request: BatchDefinitionRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionIdPut(Id: number, Request: BatchDefinitionRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionIdPut(Id: number, Request: BatchDefinitionRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling batchMgrV1BatchDefinitionIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1BatchDefinitionIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<BatchDefinitionResponseType>(`${this.basePath}/BatchMgr/V1/BatchDefinition/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_CreateBatchDefinition, Create BatchDefinition
     * Create BatchDefinition
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchDefinitionPost(Request: BatchDefinitionRequestType, observe?: 'body', reportProgress?: boolean): Observable<BatchDefinitionResponseType>;
    public batchMgrV1BatchDefinitionPost(Request: BatchDefinitionRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionPost(Request: BatchDefinitionRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchDefinitionResponseType>>;
    public batchMgrV1BatchDefinitionPost(Request: BatchDefinitionRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1BatchDefinitionPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<BatchDefinitionResponseType>(`${this.basePath}/BatchMgr/V1/BatchDefinition`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatchByParams, Retrieve Batch
     * Retrieve Batch by Query params
     * @param StartDateTime Enter the StartDateTime for yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the EndDateTime in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param GroupId Enter the GroupId
     * @param DataPipeLineId Enter the DataPipeLineId
     * @param Status Enter the Status
     * @param PageNumber Enter the PageNumber
     * @param PageSize Enter the PageSize
     * @param SortBy Enter the SortBy
     * @param SortOrder Enter the SortOrder
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchGet(StartDateTime: string, EndDateTime: string, GroupId?: number, DataPipeLineId?: number, Status?: number, PageNumber?: number, PageSize?: number, SortBy?: string, SortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<BatchResponseList>;
    public batchMgrV1BatchGet(StartDateTime: string, EndDateTime: string, GroupId?: number, DataPipeLineId?: number, Status?: number, PageNumber?: number, PageSize?: number, SortBy?: string, SortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchResponseList>>;
    public batchMgrV1BatchGet(StartDateTime: string, EndDateTime: string, GroupId?: number, DataPipeLineId?: number, Status?: number, PageNumber?: number, PageSize?: number, SortBy?: string, SortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchResponseList>>;
    public batchMgrV1BatchGet(StartDateTime: string, EndDateTime: string, GroupId?: number, DataPipeLineId?: number, Status?: number, PageNumber?: number, PageSize?: number, SortBy?: string, SortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (StartDateTime === null || StartDateTime === undefined) {
            throw new Error('Required parameter StartDateTime was null or undefined when calling batchMgrV1BatchGet.');
        }
        if (EndDateTime === null || EndDateTime === undefined) {
            throw new Error('Required parameter EndDateTime was null or undefined when calling batchMgrV1BatchGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (DataPipeLineId !== undefined) {
            queryParameters = queryParameters.set('DataPipeLineId', <any>DataPipeLineId);
        }
        if (Status !== undefined) {
            queryParameters = queryParameters.set('Status', <any>Status);
        }
        if (PageNumber !== undefined) {
            queryParameters = queryParameters.set('PageNumber', <any>PageNumber);
        }
        if (PageSize !== undefined) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }
        if (SortBy !== undefined) {
            queryParameters = queryParameters.set('SortBy', <any>SortBy);
        }
        if (SortOrder !== undefined) {
            queryParameters = queryParameters.set('SortOrder', <any>SortOrder);
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<BatchResponseList>(`${this.basePath}/BatchMgr/V1/Batch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatchLogByBatchId, Retrieve BatchLog by BatchId
     * Retrieve BatchLog by BatchId
     * @param BatchId Enter the BatchId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchLogBatchIdGet(BatchId: number, observe?: 'body', reportProgress?: boolean): Observable<BatchResponseList3>;
    public batchMgrV1BatchLogBatchIdGet(BatchId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchResponseList3>>;
    public batchMgrV1BatchLogBatchIdGet(BatchId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchResponseList3>>;
    public batchMgrV1BatchLogBatchIdGet(BatchId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (BatchId === null || BatchId === undefined) {
            throw new Error('Required parameter BatchId was null or undefined when calling batchMgrV1BatchLogBatchIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<BatchResponseList3>(`${this.basePath}/BatchMgr/V1/BatchLog/${encodeURIComponent(String(BatchId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_BatchProcessorDownload, Retrieve Batch Job Download by BatchId
     * Retrieve Batch Job Download by BatchId
     * @param BatchId Enter BatchId
     * @param GroupId Enter GroupId
     * @param DataPipeLineId Enter DataPipeLineId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchProcessorDownloadGet(BatchId: number, GroupId: number, DataPipeLineId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public batchMgrV1BatchProcessorDownloadGet(BatchId: number, GroupId: number, DataPipeLineId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public batchMgrV1BatchProcessorDownloadGet(BatchId: number, GroupId: number, DataPipeLineId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public batchMgrV1BatchProcessorDownloadGet(BatchId: number, GroupId: number, DataPipeLineId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (BatchId === null || BatchId === undefined) {
            throw new Error('Required parameter BatchId was null or undefined when calling batchMgrV1BatchProcessorDownloadGet.');
        }
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling batchMgrV1BatchProcessorDownloadGet.');
        }
        if (DataPipeLineId === null || DataPipeLineId === undefined) {
            throw new Error('Required parameter DataPipeLineId was null or undefined when calling batchMgrV1BatchProcessorDownloadGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (BatchId !== undefined) {
            queryParameters = queryParameters.set('BatchId', <any>BatchId);
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (DataPipeLineId !== undefined && DataPipeLineId !== null) {
            headers = headers.set('DataPipeLineId', String(DataPipeLineId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream',
            'application/csv'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<any>(`${this.basePath}/BatchMgr/V1/BatchProcessor/Download`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatchProcessor, Retrieve Batch Job Download by DataPipeLineId
     * Retrieve Batch Job Download by DataPipeLineId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchProcessorPost(Request: BatchJobDownloadRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public batchMgrV1BatchProcessorPost(Request: BatchJobDownloadRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public batchMgrV1BatchProcessorPost(Request: BatchJobDownloadRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public batchMgrV1BatchProcessorPost(Request: BatchJobDownloadRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1BatchProcessorPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*',
            'application/octet-stream',
            'application/csv'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/BatchMgr/V1/BatchProcessor`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_BatchProcessorResend, Resend Batch File
     * Resend Batch File
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchProcessorResendPost(Request: BatchDownloadResend, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public batchMgrV1BatchProcessorResendPost(Request: BatchDownloadResend, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public batchMgrV1BatchProcessorResendPost(Request: BatchDownloadResend, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public batchMgrV1BatchProcessorResendPost(Request: BatchDownloadResend, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1BatchProcessorResendPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/BatchMgr/V1/BatchProcessor/Resend`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveBatch, Retrieve Batch
     * Retrieve Batch by Query params
     * @param GroupId Enter the GroupId
     * @param DataPipeLineId Enter DataPipeLineId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1BatchRetrievePost(GroupId: number, DataPipeLineId: number, Request: BatchRequest, observe?: 'body', reportProgress?: boolean): Observable<BatchResponseList2>;
    public batchMgrV1BatchRetrievePost(GroupId: number, DataPipeLineId: number, Request: BatchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BatchResponseList2>>;
    public batchMgrV1BatchRetrievePost(GroupId: number, DataPipeLineId: number, Request: BatchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BatchResponseList2>>;
    public batchMgrV1BatchRetrievePost(GroupId: number, DataPipeLineId: number, Request: BatchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling batchMgrV1BatchRetrievePost.');
        }
        if (DataPipeLineId === null || DataPipeLineId === undefined) {
            throw new Error('Required parameter DataPipeLineId was null or undefined when calling batchMgrV1BatchRetrievePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1BatchRetrievePost.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }
        if (DataPipeLineId !== undefined && DataPipeLineId !== null) {
            headers = headers.set('DataPipeLineId', String(DataPipeLineId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<BatchResponseList2>(`${this.basePath}/BatchMgr/V1/Batch/Retrieve`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveDataPipeLineBatch, Retrieve a DataPipeLine with most recent Batch info
     * Retrieve a DataPipeLine with most recent Batch info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineAdvRetrieveGet(observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineRetrieveResponseTypeList3>;
    public batchMgrV1DataPipeLineAdvRetrieveGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineRetrieveResponseTypeList3>>;
    public batchMgrV1DataPipeLineAdvRetrieveGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineRetrieveResponseTypeList3>>;
    public batchMgrV1DataPipeLineAdvRetrieveGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DataPipeLineRetrieveResponseTypeList3>(`${this.basePath}/BatchMgr/V1/DataPipeLine/AdvRetrieve`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveDataPipeLine, Retrieve a DataPipeLine info
     * Retrieve DataPipeLine info
     * @param GroupId Enter GroupId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineGet(GroupId: number, observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineRetrieveResponseTypeList>;
    public batchMgrV1DataPipeLineGet(GroupId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineRetrieveResponseTypeList>>;
    public batchMgrV1DataPipeLineGet(GroupId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineRetrieveResponseTypeList>>;
    public batchMgrV1DataPipeLineGet(GroupId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (GroupId === null || GroupId === undefined) {
            throw new Error('Required parameter GroupId was null or undefined when calling batchMgrV1DataPipeLineGet.');
        }

        let headers = this.defaultHeaders;
        if (GroupId !== undefined && GroupId !== null) {
            headers = headers.set('GroupId', String(GroupId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DataPipeLineRetrieveResponseTypeList>(`${this.basePath}/BatchMgr/V1/DataPipeLine`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveDataPipeLineHistory, Retreive Data pipe line history
     * Retreive Data pipe line history
     * @param DataPipeLineId Enter the DataPipeLineId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineHistoryDataPipeLineIdGet(DataPipeLineId: number, observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineHistRetrieveList>;
    public batchMgrV1DataPipeLineHistoryDataPipeLineIdGet(DataPipeLineId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineHistRetrieveList>>;
    public batchMgrV1DataPipeLineHistoryDataPipeLineIdGet(DataPipeLineId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineHistRetrieveList>>;
    public batchMgrV1DataPipeLineHistoryDataPipeLineIdGet(DataPipeLineId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (DataPipeLineId === null || DataPipeLineId === undefined) {
            throw new Error('Required parameter DataPipeLineId was null or undefined when calling batchMgrV1DataPipeLineHistoryDataPipeLineIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DataPipeLineHistRetrieveList>(`${this.basePath}/BatchMgr/V1/DataPipeLineHistory/${encodeURIComponent(String(DataPipeLineId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_DeleteDataPipeLine, Delete a DataPipeLine
     * Delete a DataPipeLine
     * @param Id Enter the DataPipeLineId that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public batchMgrV1DataPipeLineIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public batchMgrV1DataPipeLineIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public batchMgrV1DataPipeLineIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling batchMgrV1DataPipeLineIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/BatchMgr/V1/DataPipeLine/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_UpdateDataPipeLine, Update a Data pipe line
     * Update a Data pipe line
     * @param Id Enter the DataPipeLineId that needs to be retrieved
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineIdPut(Id: number, Request: DataPipeLineUpdateRequestType, observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineUpdateResponseType>;
    public batchMgrV1DataPipeLineIdPut(Id: number, Request: DataPipeLineUpdateRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineUpdateResponseType>>;
    public batchMgrV1DataPipeLineIdPut(Id: number, Request: DataPipeLineUpdateRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineUpdateResponseType>>;
    public batchMgrV1DataPipeLineIdPut(Id: number, Request: DataPipeLineUpdateRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling batchMgrV1DataPipeLineIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1DataPipeLineIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<DataPipeLineUpdateResponseType>(`${this.basePath}/BatchMgr/V1/DataPipeLine/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_CreateDataPipeLine, Create a Data pipe line
     * Create a Data pipe line
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLinePost(Request: DataPipeLineCreateRequestType, observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineCreateResponseType>;
    public batchMgrV1DataPipeLinePost(Request: DataPipeLineCreateRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineCreateResponseType>>;
    public batchMgrV1DataPipeLinePost(Request: DataPipeLineCreateRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineCreateResponseType>>;
    public batchMgrV1DataPipeLinePost(Request: DataPipeLineCreateRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1DataPipeLinePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DataPipeLineCreateResponseType>(`${this.basePath}/BatchMgr/V1/DataPipeLine`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveAllDataPipeLine, Retrieve a Data pipe line
     * Retrieve a Data pipe line
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataPipeLineRetrievePost(Request: DataPipeLineRetrieveRequestType, observe?: 'body', reportProgress?: boolean): Observable<DataPipeLineRetrieveResponseTypeList2>;
    public batchMgrV1DataPipeLineRetrievePost(Request: DataPipeLineRetrieveRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataPipeLineRetrieveResponseTypeList2>>;
    public batchMgrV1DataPipeLineRetrievePost(Request: DataPipeLineRetrieveRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataPipeLineRetrieveResponseTypeList2>>;
    public batchMgrV1DataPipeLineRetrievePost(Request: DataPipeLineRetrieveRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1DataPipeLineRetrievePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DataPipeLineRetrieveResponseTypeList2>(`${this.basePath}/BatchMgr/V1/DataPipeLine/Retrieve`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveDataProcessor, Retrieve DataProcessors
     * Retrieve DataProcessors
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataProcessorGet(observe?: 'body', reportProgress?: boolean): Observable<DataProcessorResponseList>;
    public batchMgrV1DataProcessorGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProcessorResponseList>>;
    public batchMgrV1DataProcessorGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProcessorResponseList>>;
    public batchMgrV1DataProcessorGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get<DataProcessorResponseList>(`${this.basePath}/BatchMgr/V1/DataProcessor`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveDataProviderInfo, Retrieve Data Provider Info
     * Retrieve Data Provider Info
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataProviderInfoPost(Request: DataProviderInfoRequestType, observe?: 'body', reportProgress?: boolean): Observable<DataProviderInfoResponseType>;
    public batchMgrV1DataProviderInfoPost(Request: DataProviderInfoRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProviderInfoResponseType>>;
    public batchMgrV1DataProviderInfoPost(Request: DataProviderInfoRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProviderInfoResponseType>>;
    public batchMgrV1DataProviderInfoPost(Request: DataProviderInfoRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1DataProviderInfoPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DataProviderInfoResponseType>(`${this.basePath}/BatchMgr/V1/DataProvider/Info`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_DataProviderSubList, Retrieve Data Provider sublist
     * Retrieve Data Provider sublist
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataProviderSubListPost(Request: DataProviderSubListRequestType, observe?: 'body', reportProgress?: boolean): Observable<DataProviderSubListResponseType>;
    public batchMgrV1DataProviderSubListPost(Request: DataProviderSubListRequestType, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DataProviderSubListResponseType>>;
    public batchMgrV1DataProviderSubListPost(Request: DataProviderSubListRequestType, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DataProviderSubListResponseType>>;
    public batchMgrV1DataProviderSubListPost(Request: DataProviderSubListRequestType, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling batchMgrV1DataProviderSubListPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DataProviderSubListResponseType>(`${this.basePath}/BatchMgr/V1/DataProvider/SubList`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * BatchMgr_RetrieveAllDataSources, Get all DataSources
     * Get all DataSources
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public batchMgrV1DataSourceGet(observe?: 'body', reportProgress?: boolean): Observable<GetDataSourceResponseInfoList>;
    public batchMgrV1DataSourceGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetDataSourceResponseInfoList>>;
    public batchMgrV1DataSourceGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetDataSourceResponseInfoList>>;
    public batchMgrV1DataSourceGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetDataSourceResponseInfoList>(`${this.basePath}/BatchMgr/V1/DataSource`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
